"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MfaLogin;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _SMSEnterCode = _interopRequireDefault(require("./steps/SMSEnterCode"));

var _TOTPInputCode = _interopRequireDefault(require("./steps/TOTPInputCode"));

var _Button = _interopRequireDefault(require("../../components/Button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _constants = require("../../utils/constants");

var _Text = require("./Text");

var _MaskInput = require("./MaskInput");

function Submit(_ref) {
  var disabled = _ref.disabled,
      loading = _ref.loading,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["disabled", "loading", "children"]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    disabled: disabled || loading,
    className: "md:w-56"
  }, rest), loading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    size: 24,
    color: "inherit"
  })) : children ? children : t('button.verify'));
}

var RecoveryCode = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var onValidate = _ref2.onValidate,
      _ref2$dialog = _ref2.dialog,
      dialog = _ref2$dialog === void 0 ? false : _ref2$dialog;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var inputRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var handleValidate = function handleValidate() {
    var code = inputRef.current.value;

    if (code.trim().length < 8) {
      setError(true);
      return Promise.reject('Invalid code');
    }

    setLoading(true);
    return onValidate(code).then(function (res) {
      return res;
    })["catch"](function (e) {
      setError(true);
      setLoading(false);
      throw e;
    });
  };

  var body = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text.PrimaryText, {
    className: 'text-3xl'
  }, "Enter your recovery code"), /*#__PURE__*/_react["default"].createElement(_Text.SecondaryText, null, "This code can only be used once. Once logged in you will need to update your 2-factor authentication settings to secure your account with another device."), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "code",
    className: "text-gray-light text-sm font-semibold my-2 block"
  }, "RECOVERY CODE"), /*#__PURE__*/_react["default"].createElement(_MaskInput.RecoveryCodeInput, {
    id: "code",
    className: "block w-full",
    autoFocus: true,
    standalone: true,
    defaultValue: "",
    placeholder: "",
    onKeyDown: function onKeyDown(e) {
      e.key === 'Enter' && handleValidate();
    },
    ref: inputRef
  })), error && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-red text-sm pt-2"
  }, "Error recovery code"));

  var button = /*#__PURE__*/_react["default"].createElement(Submit, {
    onClick: handleValidate,
    loading: loading
  }, "Recover My Account");

  if (dialog) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
      style: {
        minHeight: 280
      }
    }, body), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
      className: "!px-6 !py-4",
      style: {
        justifyContent: 'flex-start'
      }
    }, button));
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-8"
    }, button));
  }
});

var EnterCode = function EnterCode(_ref3) {
  var method = _ref3.method,
      dialog = _ref3.dialog,
      phoneNumber = _ref3.phoneNumber,
      onVerify = _ref3.onVerify,
      onSendCode = _ref3.onSendCode,
      onEnterRecoveryCode = _ref3.onEnterRecoveryCode;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var handleClick = function handleClick() {
    setLoading(true);
    enterCodeRef.current.next()["catch"](function () {
      return setLoading(false);
    });
  };

  var enterCodeRef = (0, _react.useRef)();
  var body = method === _constants.AUTH_SETTING_METHOD.sms ? /*#__PURE__*/_react["default"].createElement(_SMSEnterCode["default"], {
    ref: enterCodeRef,
    phoneNumber: phoneNumber,
    onVerify: onVerify,
    onSendCode: onSendCode,
    onNext: handleClick,
    login: true
  }) : /*#__PURE__*/_react["default"].createElement(_TOTPInputCode["default"], {
    ref: enterCodeRef,
    login: true,
    onNext: handleClick,
    onVerify: onVerify
  });

  var button = /*#__PURE__*/_react["default"].createElement(Submit, {
    onClick: handleClick,
    loading: loading
  });

  var tip = /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs"
  }, "Lost your device?", ' ', /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onEnterRecoveryCode,
    className: "text-primary",
    disabled: loading
  }, "Enter your recovery code"));

  if (dialog) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
      style: {
        minHeight: 280
      }
    }, body), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
      className: "!px-6 !py-4",
      style: {
        justifyContent: 'space-between'
      }
    }, button, tip));
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-8"
    }, button), tip);
  }
};

function MfaLogin(_ref4) {
  var phoneNumber = _ref4.phoneNumber,
      onVerify = _ref4.onVerify,
      onSendCode = _ref4.onSendCode,
      onValidateRecoveryCode = _ref4.onValidateRecoveryCode,
      method = _ref4.method,
      _ref4$dialog = _ref4.dialog,
      dialog = _ref4$dialog === void 0 ? false : _ref4$dialog,
      isOpen = _ref4.isOpen,
      onClose = _ref4.onClose;

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      recoveryCode = _useState8[0],
      setRecoveyCode = _useState8[1];

  var handleEnterRecoveryCode = function handleEnterRecoveryCode() {
    setRecoveyCode(true);
  };

  var body = recoveryCode ? /*#__PURE__*/_react["default"].createElement(RecoveryCode, {
    dialog: dialog,
    onValidate: onValidateRecoveryCode
  }) : /*#__PURE__*/_react["default"].createElement(EnterCode, {
    dialog: dialog,
    method: method,
    phoneNumber: phoneNumber,
    onVerify: onVerify,
    onSendCode: onSendCode,
    onEnterRecoveryCode: handleEnterRecoveryCode
  });

  if (dialog) {
    return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
      open: isOpen,
      fullWidth: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
      onClose: onClose
    }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
      className: "text-right"
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      className: "cursor-pointer",
      fontSize: "small",
      onClick: onClose
    })), body);
  } else {
    return body;
  }
}
//# sourceMappingURL=MfaLogin.js.map